import React, { useEffect } from 'react';
import PopUp from "../../GeneralComponents/PopUp";
import ClickedNewPagePopUp from './ClickedNewPagePopUp';

/*
This component renders a pop up that is being displayed when there is a unsaved page and user tries to create a new page.
It asks the user to save - dont save or cancel.
*/
const ValidationClickedNewPage = (props) => {
  const {
    openAlert,
    setOpenAlert,
    newPageClicked,
    savedPageClicked,
    selectedProject,
    selectedPage
  } = props;

  const [clickedNewPage, setClickedNewPage] = React.useState(false);
  const [pageName, setPageName] = React.useState('');

  useEffect(() => {
    if (selectedPage > -1 && selectedProject > -1) {
      const tempData = JSON.parse(localStorage.getItem('data'));

      if (tempData[selectedProject] !== undefined) {
        const tempPageName = tempData[selectedProject].pages[selectedPage].name;
        setPageName(tempPageName);
      }
    }
  }, [openAlert]);


   // This function is fired when user clicks dont save.It closes the pop up and creates a new page
  const handleDontSave = () => {
    setOpenAlert(false);
    setClickedNewPage(true);
  };

  // This function is fired when user clicks dont save.It closes the pop up, saves the previous page and creates a new page
  const handleSave = () => {
    savedPageClicked();
    setOpenAlert(false);
    setClickedNewPage(true);
  };

  return (
    <>
      <PopUp
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        handleCancel={handleDontSave}
        handleConfirm={handleSave}
        title={`Do you want to save ${  pageName  } ?`}
        insideDescription={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignSelf: 'center' }}>A new page will be created.</div>
            <div>All changes will be lost if you create new page.</div>
          </div>
        }
        confirmText='Save'
        cancelText='Cancel'
      />
      <ClickedNewPagePopUp
        clickedNewPage={clickedNewPage}
        setClickedNewPage={setClickedNewPage}
        selectedProject={selectedProject}
        newPageClicked={newPageClicked}
      />
    </>
  );
};

export default ValidationClickedNewPage;
